export function getNextStep(currentIndex: number, totalElement: number, loop: boolean) {
    return currentIndex + 1 > totalElement - 1 ? (loop ? 0 : currentIndex) : currentIndex + 1;
}

export function getPrevStep(currentIndex: number, totalElement: number, loop: boolean) {
    return currentIndex - 1 < 0 ? (loop ? totalElement - 1 : currentIndex) : currentIndex - 1;
}
